import { addressAdd, addressUpdate } from "@/apis/address";
import { CurrencySelect } from "@/components/Selector";
import { WAddress } from "@/types/address";
import { Form, Input, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


interface AddressFormProps {
  formType: "ADD" | "EDIT" | "DETAIL",
  formData?: WAddress;
  onOk: (res: WAddress) => void;
  onCancel: () => void;
}
const AddressForm: React.FC<AddressFormProps> = ({ formType, formData, onCancel, onOk }) => {

  const [form] = Form.useForm<WAddress>();
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (formData) form.setFieldsValue({ ...formData })
  }, [formData])

  const submit = (values: WAddress) => {
    setLoading(true)
    if (formType === "ADD") {
      addressAdd({
        ...values,
        label2: '',
        label3: '',
      })
        .then(res => {
          notification.success({ placement: 'top', message: t('layout.addSuccess') })
          onOk(res)
        })
        .catch(err => {
          notification.error({ placement: 'top', message: t('layout.addFailed') })
        })
        .finally(() => setLoading(false))
    }
    if (formType === "EDIT") {
      addressUpdate({
        ...values,
        label2: '',
        label3: '',
        id: formData?.id
      })
        .then(res => {
          notification.success({ placement: 'top', message: t('common.saveOk') })
          onOk(res)
        })
        .catch(err => {
          notification.error({ placement: 'top', message: t('common.saveFAil') })
        })
        .finally(() => setLoading(false))
    }

  }
  return (
    <Modal maskClosable={false} onCancel={onCancel} onOk={() => form.submit()}
      open={true} title={t('purchase.address')}
      okButtonProps={{ loading: loading }}
    >
      <Form<WAddress> form={form} onFinish={submit} disabled={formType === "DETAIL"}>
        <Form.Item<WAddress> name="receiver" label={t('purchase.accer')}>
          <Input placeholder={t('purchase.accer')} />
        </Form.Item>
        <Form.Item<WAddress> name="contact" label={t('purchase.contact')}>
          <Input placeholder={t('purchase.contact')} />
        </Form.Item>
        <Form.Item<WAddress> name="mobile" label={t('purchase.phone1')}>
          <Input placeholder={t('purchase.phone1')} />
        </Form.Item>
        <Form.Item<WAddress> name="zip" label={t('purchase.zipCode')}>
          <Input placeholder={t('purchase.zipCode')} />
        </Form.Item>
        <Form.Item<WAddress> name="address" label={t('purchase.address')}
          rules={[
            { required: true, message: t("purchase.address") }
          ]}>
          <Input.TextArea placeholder={t('purchase.address')} autoSize={{ maxRows: 4, minRows: 2 }} maxLength={200} showCount />
        </Form.Item>
        <Form.Item<WAddress> name="label1" label={t('purchase.currency')}
          rules={[
            { required: true, message: t("components.plCurrency") }
          ]}>
          <CurrencySelect />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddressForm;